import React, { FC, ReactNode } from 'react';
import { Theme } from 'evcharging/app/themes';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import useI18n from 'evcharging/hooks/useI18n';
import Paragraph from 'evcharging/components/Paragraph';
import Spacer from 'evcharging/components/Spacer';
import DarkLinkButton from 'evcharging/components/DarkLinkButton';

interface ServiceItemProps {
  image: string;
  title: string;
  text: ReactNode;
  label: string;
  href: string;
  topSpace?: boolean;
  bottomSpace?: boolean;
}

const SolutionItem: FC<ServiceItemProps> = (props) => {
  const { image, title, text, label, href, bottomSpace, topSpace } = props;
  const theme = useTheme();
  const styles = createStyles(theme, image);
  const { t } = useI18n();

  return (
    <div className={styles.root}>
      {topSpace && <Spacer value={32} mobile={0} />}
      <div className={styles.image} />
      <Spacer value={24} mobile={0} />
      <p className={styles.title}>{title}</p>
      <Spacer value={14} />
      <Paragraph color={'middle'} size={'small'} maxWidth={551}>
        {text}
      </Paragraph>
      <Spacer value={48} mobile={32} />
      <DarkLinkButton href={href}>{label}</DarkLinkButton>
      {bottomSpace && <Spacer value={32} mobile={0} />}
    </div>
  );
};

const createStyles = (theme: Theme, image: string) => ({
  root: css`
    background: #F6F8F9;

    :last-child {
      padding-left: 39px;
      border-left: 1.3px #e1dede solid;
    }

    ${theme.breakpoints.mobile.down} {
      :last-child {
        padding-left: unset;
      }
    }
  `,
  image: css`
    background-image: url(${image});
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 12px;
    height: 200px;
    max-width: 551px;

    ${theme.breakpoints.mobile.down} {
      max-width: 350px;
      width: unset;
    }
  `,
  title: css`
    color: #303940;
    font-weight: 800;
    font-size: 32px;
    line-height: 41px;

    ${theme.breakpoints.mobile.down} {
      font-size: 20px;
      padding-top: 24px;
    }
  `
});

export default SolutionItem;